import i18n from 'utils/i18n';
import * as Yup from 'yup';

export const validationSchema = () =>
  Yup.object().shape({
    user: Yup.number().required(i18n.t('errors.required')).nullable(),
    start_date: Yup.string().required(i18n.t('errors.required')).nullable(),
  });
